<script>
  import { setLanguage, getLanguage } from "i18n/language.js";

  $: ENactive = $getLanguage === "en";
  $: ITactive = $getLanguage === "it";

  const setLang = (lang) => {
    setLanguage(lang);
  };
</script>

<div class="langs">
  <div class={ENactive ? "active" : ""} on:click={() => setLang("en")}>EN</div>
  <div class={ITactive ? "active" : ""} on:click={() => setLang("it")}>IT</div>
</div>

<style>
  .langs {
    display: flex;
    font-size: 14px;
  }

  .langs > :global(* + *) {
    margin-left: 12px;
  }

  .langs > :global(.active) {
    color: var(--accent);
  }
</style>
